import React, { useState } from "react";
import { Input, Button, Form, Label } from "reactstrap";
import ClearFilterImg from "../../assets/images/clear-filter.svg";

const DateFilter = ({ onApply }) => {
	const [fromValue, setFromValue] = useState("");
	const [toValue, setToValue] = useState("");
	const [error, setError] = useState("");

	const showPicker = (input) => {
		if (typeof input.showPicker === "function") {
			try {
				input.showPicker();
			} catch {
				// window.location.reload();
			}
		}
	};

	const handleMouseDown = (e) => {
		e.preventDefault();
		showPicker(e.currentTarget);
	};

	const handleKeyDown = (e) => {
		if (e.key === "Tab") {
			return;
		}
		e.preventDefault();
		if (e.key === "Enter" || e.key === " ") {
			showPicker(e.currentTarget);
		}
	};

	const handleApply = () => {
		if (!fromValue || !toValue) {
			setError("Both dates are required.");
			return;
		}
		if (new Date(fromValue) > new Date(toValue)) {
			setError("'From' date cannot be later than 'To' date.");
			return;
		}
		setError("");
		onApply({ from: fromValue, to: toValue });
	};

	return (
		<Form className="d-flex align-items-baseline gap-2">
			<Label className="fw-bold mb-0">Date Filter:</Label>
			<div className="d-flex flex-column">
				<div className="d-flex align-items-center gap-2 flex-row">
					<span>From</span>
					<Input
						type="date"
						value={fromValue}
						max={toValue || undefined}
						onChange={(e) => setFromValue(e.target.value)}
						onMouseDown={handleMouseDown}
						onKeyDown={handleKeyDown}
						className="date-filter-input"
						style={{ width: "160px", cursor: "pointer" }}
						data-testid="fromDateFilter"
					/>
					<span>To</span>
					<Input
						type="date"
						value={toValue}
						min={fromValue || undefined}
						onChange={(e) => setToValue(e.target.value)}
						onMouseDown={handleMouseDown}
						onKeyDown={handleKeyDown}
						className="date-filter-input"
						style={{ width: "160px", cursor: "pointer" }}
						data-testid="toDateFilter"
					/>
				</div>
				{error && <span className="text-danger small">{error}</span>}
			</div>
			<Button
				color="primary"
				onClick={handleApply}
				disabled={!fromValue || !toValue}
			>
				Apply
			</Button>
			<img
				src={ClearFilterImg}
				alt="Clear Filter"
				style={{ cursor: "pointer" }}
				onClick={() => {
					setFromValue("");
					setToValue("");
					setError("");
					onApply({ from: null, to: null });
				}}
			/>
		</Form>
	);
};

export default DateFilter;
